export default "__VITE_ASSET__DyuZDcq9__"